import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { QuestionOption, QuestionCard, QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { QuestionCardForm } from './question-card-form.model';
import { IQuestionOptionForm, IQuestionCardForm } from './question-form-group.interface';
import { QuestionForm } from './question-form.model';
import { QuestionOptionForm } from './question-option-form.model';
import { ChoiceQuestionSettingsForm } from '../survey-editor/choice-question-settings-form.model';

export class QuestionFormCarousel extends QuestionForm {
  constructor() {
    super();
    this.extendFormGroup();
  }

  initEmpty(index: number, pageId: string): void {
    super.initEmpty(index, pageId);
    this.form.get('type').setValue(QuestionType.Carousel);
    (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm().form);
    (this.form.get('cards') as FormArray<FormGroup<IQuestionCardForm>>).push(new QuestionCardForm().form);
  }

  init(question: Question): void {
    super.init(question);
    this.form.get('type').setValue(QuestionType.Carousel);
    this.patchOptions(question.options);
    this.patchCards(question.cards);

    if (!question.useOtherPosition) {
      const useOtherInd = this.form.get('useOtherInd').value;
      this.form.get('useOtherPosition').setValue(useOtherInd ? this.form.get('options').value.length : -1);
    }
  }

  private extendFormGroup(): void {
    this.form.addControl('options', new FormArray<FormGroup<IQuestionOptionForm>>([]));
    this.form.addControl('otherLabel', new FormControl<string>('Other, please specify'));
    this.form.addControl('randomizedOptionsInd', new FormControl<boolean>(false));
    this.form.addControl('useOtherInd', new FormControl<boolean>(false));
    this.form.addControl('useExclusiveOtherInd', new FormControl<boolean>(true));
    this.form.addControl('useOtherPosition', new FormControl<number>(-1));
    this.form.addControl('useOtherPinnedInd', new FormControl<boolean>(false));
    this.form.addControl(
      'optionsSettings',
      new FormGroup<ChoiceQuestionSettingsForm>({
        autopopulateInd: new FormControl<boolean>(false)
      })
    );

    this.form.addControl('cards', new FormArray<FormGroup<IQuestionCardForm>>([]));
    this.form.addControl('randomizedCardsInd', new FormControl<boolean>(false));
  }

  private patchOptions(options: QuestionOption[]): void {
    if (!options || options.length === 0) {
      (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm().form);
      return;
    }
    options.forEach((option) => {
      (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm(option).form);
    });
  }

  private patchCards(cards: QuestionCard[]): void {
    if (!cards || cards.length === 0) {
      (this.form.get('cards') as FormArray<FormGroup<IQuestionCardForm>>).push(new QuestionCardForm().form);
      return;
    }
    cards.forEach((card) => {
      (this.form.get('cards') as FormArray<FormGroup<IQuestionCardForm>>).push(new QuestionCardForm(card).form);
    });
  }
}
